import { Icon, Menu } from "materia"
import { useTranslation } from "react-i18next"
import { getLocaleDisplayName } from "../../../../dataUtilities/getLocaleDisplayName"
import { changeLocale } from "../../../../i18n/changeLocale"
import { sendVuplexMessage } from "../../../../vuplex/sendVuplexMessage"
import s from "./styles.module.scss"

type Props = { locales: string[] }
export const DropdownLanguage = ({ locales }: Props) => {
  const { t, i18n } = useTranslation()

  const onLanguageChange = (localeCode: string) => {
    changeLocale(localeCode)
    sendVuplexMessage({ type: "SET_LANGUAGE", payload: { localeCode } })
  }

  return (
    <Menu>
      <Menu.Trigger dataTestId="dropdown-language-trigger">
        <div className={s.headerMenuItem}>
          <Icon
            icon="Language"
            size="extraLarge"
            className={s.headerMenuItem__thumbnail}
          />
          <div className={s.headerMenuItem__content}>
            <div className={s.headerMenuItem__title}>
              {t("settings.LANGUAGE")}
            </div>
            <div className={s.headerMenuItem__description}>
              {getLocaleDisplayName(i18n.language)}
            </div>
          </div>
        </div>
      </Menu.Trigger>

      <Menu.Content>
        {locales.map((locale) => (
          <Menu.Item
            as="button"
            key={locale}
            isActive={i18n.language === locale}
            onClick={() => onLanguageChange(locale)}
          >
            {getLocaleDisplayName(locale)}
          </Menu.Item>
        ))}
      </Menu.Content>
    </Menu>
  )
}
